// Black-Scholes-Merton call — PSD §4.2.3. Engine layer (framework-free).
import { normCDF } from './norm';
import { safeExp } from './norm';
/**
 * Generalized Black-Scholes-Merton call option value with continuous dividend yield.
 *
 * S = equity value at boundary
 * X = breakpoint strike
 * T = timeToLiquidity (years)
 * r = riskFreeRate
 * sigma = volatility
 * q = dividendYield
 */
export function bsCall(S, X, T, r, sigma, q) {
    if (S <= 0)
        return 0;
    if (T <= 0)
        return Math.max(S - X, 0); // at/after expiry: intrinsic
    if (sigma <= 0)
        return Math.max(S - X * safeExp(-r * T), 0); // degenerate: deterministic discount
    const sqrtT = Math.sqrt(T);
    const d1 = (Math.log(S / X) + (r - q + (sigma * sigma) / 2) * T) / (sigma * sqrtT);
    const d2 = d1 - sigma * sqrtT;
    const Nd1 = normCDF(d1);
    const Nd2 = normCDF(d2);
    return S * safeExp(-q * T) * Nd1 - X * safeExp(-r * T) * Nd2;
}
/** Black-Scholes put (used by DLOM protective-put models in Phase 2). */
export function bsPut(S, X, T, r, sigma, q) {
    if (S <= 0)
        return X * safeExp(-r * T);
    if (T <= 0)
        return Math.max(X - S, 0);
    if (sigma <= 0)
        return Math.max(X * safeExp(-r * T) - S, 0);
    const sqrtT = Math.sqrt(T);
    const d1 = (Math.log(S / X) + (r - q + (sigma * sigma) / 2) * T) / (sigma * sqrtT);
    const d2 = d1 - sigma * sqrtT;
    const negNd1 = normCDF(-d1);
    const negNd2 = normCDF(-d2);
    return X * safeExp(-r * T) * negNd2 - S * safeExp(-q * T) * negNd1;
}
//# sourceMappingURL=blackScholes.js.map